export default function HotdogIcon({ className = "h-6 w-6" }) {
    return (
        <svg viewBox="0 0 32 20" fill="none" className={className} aria-hidden="true">
            <path
                d="M3 11.5C3 8.5 5.5 6.5 9 6.5h14c3.5 0 6 2 6 5s-2.5 5-6 5H9c-3.5 0-6-2-6-5Z"
                stroke="currentColor"
                strokeWidth="1.6"
            />
            <path
                d="M6 11.5c0-1.8 1.4-3 3.5-3h13c2.1 0 3.5 1.2 3.5 3s-1.4 3-3.5 3h-13c-2.1 0-3.5-1.2-3.5-3Z"
                fill="currentColor"
                opacity="0.9"
            />
            <path
                d="M8 11.5c1-1.2 2-1.2 3 0s2 1.2 3 0 2-1.2 3 0 2 1.2 3 0 2-1.2 3 0"
                stroke="#FFFDF9"
                strokeWidth="1.4"
                strokeLinecap="round"
            />
        </svg>
    );
}
